import { managerTimesheet } from "../../Api/managerTimesheet";
import {
  UPDATE_MANAGER_SCHEDULEHOURS_REQUEST,
  UPDATE_MANAGER_SCHEDULEHOURS_SUCCESS,
  UPDATE_MANAGER_SCHEDULEHOURS_FAILURE,
  UPDATE_MANAGER_WEEKLYSCHEDULE_REQUEST,
  UPDATE_MANAGER_WEEKLYSCHEDULE_SUCCESS,
  UPDATE_MANAGER_WEEKLYSCHEDULE_FAILURE
} from "../../Constants";

function requestUpdateScheduleHours() {
  return {
    type: UPDATE_MANAGER_SCHEDULEHOURS_REQUEST,
    isFetching: true
  };
}

function updateScheduleHoursSuccess(data) {
  return {
    type: UPDATE_MANAGER_SCHEDULEHOURS_SUCCESS,
    isFetching: false,
    data
  };
}

function updateScheduleHoursError(errorMessage) {
  return {
    type: UPDATE_MANAGER_SCHEDULEHOURS_FAILURE,
    isFetching: false,
    errorMessage
  };
}
function requestupdateWeeklySchedule() {
  return {
    type: UPDATE_MANAGER_WEEKLYSCHEDULE_REQUEST,
    isFetching: true
  };
}

function updateWeeklyScheduleSuccess(data) {
  return {
    type: UPDATE_MANAGER_WEEKLYSCHEDULE_SUCCESS,
    isFetching: false,
    data
  };
}

function updateWeeklyScheduleError(errorMessage) {
  return {
    type: UPDATE_MANAGER_WEEKLYSCHEDULE_FAILURE,
    isFetching: false,
    errorMessage
  };
}



export const updateManagerScheduleHours = payload => (dispatch, getState) => {
  dispatch(requestUpdateScheduleHours());
  managerTimesheet
    .updateScheduleHourManager(payload)
    .then(res => {
      dispatch(updateScheduleHoursSuccess(res));
    })
    .catch(err => dispatch(updateScheduleHoursError(err)));
};
export const updateManagerWeeklySchedule = payload => (dispatch, getState) => {
  dispatch(requestupdateWeeklySchedule());
  managerTimesheet
    .updateWeeklyScheduleManager(payload)
    .then(res => {
      dispatch(updateWeeklyScheduleSuccess(res));
    })
    .catch(err => dispatch(updateWeeklyScheduleError(err)));
};


export const resetWeeklyScheduleMessage = payload => (dispatch, getState) => {
  dispatch(updateWeeklyScheduleSuccess(""));
};

export const resetScheduleHoursMessage = payload => (dispatch, getState) => {
  dispatch(updateScheduleHoursSuccess(""));
};
